export default __webpack_public_path__ + "static/media/App_store.4b373024.png";